import { useMutation, useQuery } from 'react-query';
import * as casesService from 'services/casesService';
import { ExportDto } from 'types/dto';
import { GetCasesDto } from 'types/dto/GetCasesDto';
import { GetReportsDto } from 'types/dto/GetReportsDto';
import { SearchCasesDto } from 'types/dto/SearchCasesDto';



const getCases = async (getCasesDto: GetCasesDto, options = {}) => {
  return await casesService.getCases(getCasesDto, options);
}

const searchCases = async (dto: SearchCasesDto) => {
  return await casesService.searchCases(dto);
}

const getReports = async (dto: GetReportsDto) => {
  return await casesService.getReports(dto);
}

const exportCases = async ({ userId, dto }: {
  userId: number,
  dto: ExportDto
}) => {
  return await casesService.exportCases(userId, dto);
}

// *********************************************************************
// *********************************************************************

export const useGetCases = (getCasesDto: GetCasesDto, options = {}) => {
  return useQuery<any, Error>({
    queryKey: ['cases', getCasesDto],
    queryFn: ({ signal }) => getCases(getCasesDto, { signal }),
    ...options
  });
}

export const useGetReports = (dto: GetReportsDto, options = {}) => {
  return useQuery({
    queryKey: ['reports', dto],
    queryFn: () => getReports(dto),
    ...options,
  })
}

export const useSearchCases = (dto: SearchCasesDto, options = {}) => {
  return useQuery({
    queryKey: ['cases', JSON.stringify(dto)],
    queryFn: () => searchCases(dto),
    ...options,
  })
}

export const useExportCases = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(exportCases, {
    onSuccess,
    onError,
    ...options,
  });
}